// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"87c81441","158":"1421a380","654":"8759076b","842":"a218ec36","877":"0b28d4db"}[chunkId] + ".chunk.js";
};